var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        okText: this.$store.getters.language["common.okButton"],
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: _vm.language["common.type"]
                  }
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.model.areaLevel,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "areaLevel", $$v)
                        },
                        expression: "model.areaLevel"
                      }
                    },
                    [
                      _c("a-radio", { attrs: { value: "0", disabled: "" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.language["factory"]) +
                            "\n          "
                        )
                      ]),
                      _c("a-radio", { attrs: { value: "1", disabled: "" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.language["area"]) +
                            "\n          "
                        )
                      ]),
                      _c("a-radio", { attrs: { value: "2", disabled: "" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.language["danger.build"]) +
                            "\n          "
                        )
                      ]),
                      _c("a-radio", { attrs: { value: "3", disabled: "" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.language["danger.floor"]) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.model.areaLevel == 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["factory"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        id: "factoryId",
                        prop: "factoryId"
                      }
                    },
                    [
                      _c("a-select", {
                        attrs: {
                          options: _vm.factoryOptions,
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["factory"]
                        },
                        on: { change: _vm.factoryChange },
                        model: {
                          value: _vm.model.factoryId,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "factoryId", $$v)
                          },
                          expression: "model.factoryId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.areaLevel != 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["common.name"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "areaName"
                      }
                    },
                    [
                      _c("a-input", {
                        staticStyle: { width: "85%" },
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["common.name"]
                        },
                        model: {
                          value: _vm.model.areaName,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "areaName", $$v)
                          },
                          expression: "model.areaName"
                        }
                      }),
                      _c(
                        "a-button",
                        {
                          staticStyle: { left: "3%" },
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.languageModelOpen(
                                "CstBdArea",
                                "areaName",
                                _vm.areaNameLanguages
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.language["common.language"]))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["common.code"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "areaCode",
                    disabled: _vm.model.areaLevel == 0
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["common.code"]
                    },
                    model: {
                      value: _vm.model.areaCode,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "areaCode", $$v)
                      },
                      expression: "model.areaCode"
                    }
                  })
                ],
                1
              ),
              _vm.model.areaLevel != 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["upperFirst"],
                        hasFeedback: ""
                      }
                    },
                    [
                      _c("a-tree-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          dropdownStyle: {
                            maxHeight: "200px",
                            overflow: "auto"
                          },
                          treeData: _vm.areaTree,
                          placeholder: _vm.language["column.pleaseChoose"],
                          disabled: ""
                        },
                        model: {
                          value: _vm.model.parentId,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "parentId", $$v)
                          },
                          expression: "model.parentId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.areaLevel != 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["system.centerLongitude"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["system.centerLongitude"]
                        },
                        model: {
                          value: _vm.model.longitude,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "longitude", $$v)
                          },
                          expression: "model.longitude"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.areaLevel != 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["system.centerLatitude"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["system.centerLatitude"]
                        },
                        model: {
                          value: _vm.model.latitude,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "latitude", $$v)
                          },
                          expression: "model.latitude"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.areaLevel != 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["system.altitude"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["system.altitude"]
                        },
                        model: {
                          value: _vm.model.altitude,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "altitude", $$v)
                          },
                          expression: "model.altitude"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.areaLevel != 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["system.area.coordinates"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        staticStyle: { width: "30%" },
                        model: {
                          value: _vm.model.coordinatesX,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "coordinatesX", $$v)
                          },
                          expression: "model.coordinatesX"
                        }
                      }),
                      _c("a-input", {
                        staticStyle: { width: "30%", left: "5%" },
                        model: {
                          value: _vm.model.coordinatesY,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "coordinatesY", $$v)
                          },
                          expression: "model.coordinatesY"
                        }
                      }),
                      _c("a-input", {
                        staticStyle: { width: "30%", left: "10%" },
                        model: {
                          value: _vm.model.coordinatesZ,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "coordinatesZ", $$v)
                          },
                          expression: "model.coordinatesZ"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.areaLevel != 0
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["system.isVirtual"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.model.virtual,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "virtual", $$v)
                            },
                            expression: "model.virtual"
                          }
                        },
                        [
                          _c("a-radio", { attrs: { value: "1" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.language["common.yes"]) +
                                "\n            "
                            )
                          ]),
                          _c("a-radio", { attrs: { value: "0" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.language["common.no"]) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["basedata.remark"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "remark"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["basedata.remark"]
                    },
                    model: {
                      value: _vm.model.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "remark", $$v)
                      },
                      expression: "model.remark"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-tab-pane",
                {
                  key: _vm.refKeys[0],
                  attrs: {
                    tab: _vm.language["selfCheck.ref.file"],
                    forceRender: true
                  }
                },
                [
                  _c("j-editable-table", {
                    ref: _vm.refKeys[0],
                    attrs: {
                      dragSort: true,
                      loading: _vm.pointListTable.loading,
                      columns: _vm.pointListTable.columns,
                      dataSource: _vm.pointListTable.dataSource,
                      maxHeight: 300,
                      maxNumber: 10000,
                      disabled: _vm.disableSubmit
                        ? _vm.disableSubmit
                        : _vm.formDisabled,
                      rowNumber: true,
                      "is-show-download-button": false,
                      rowSelection: true,
                      actionButton: true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }